var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M4 4c-.737 0-1.334.597-1.334 1.333v2c0 .737.597 1.334 1.333 1.334h2v.666c0 .737-.597 1.334-1.333 1.334a.667.667 0 1 0 0 1.333 2.667 2.667 0 0 0 2.667-2.667v-4C7.333 4.597 6.736 4 5.999 4H4Zm6 0c-.737 0-1.334.597-1.334 1.333v2c0 .737.597 1.334 1.333 1.334h2v.666c0 .737-.597 1.334-1.333 1.334a.667.667 0 1 0 0 1.333 2.667 2.667 0 0 0 2.667-2.667v-4c0-.736-.597-1.333-1.334-1.333h-2Z",
    clipRule: "evenodd"
  })));
};
export default SvgQuote;